import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import {
  ProtectedRoute,
  getFirstAllowedNavPath,
} from './sections/auth/ProtectedRoute';
import FinishedJobsPage from './pages/FinishedJobsPage';
import FinishedJobsDetailPage from './pages/FinishedJobsDetailPage';
import Porters from './pages/Porters';
import MuhaberatEntryPage from './pages/MuhaberatEntry';
import MuhaberatOutput from './pages/MuhaberatOutput';
import MuhaberatOutputUsers from './pages/MuhaberatOutputUsers';
import ManuelHandShake from './pages/Manuel-handshake';
import HandsfreePage from './pages/HandsfreePage';
import AllActionsPage from './pages/AllActionsPage';
import RobotListsPage from './pages/RobotListsPage';
import RobotActionsPage from './pages/RobotActionsPage';
import PriceTablePage from './pages/PriceTablePage';
import TechnicalSupportRequests from './pages/TechnicalSupportRequests';
import FormWithoutLogin from './pages/FormWithoutLogin';
import CreateEmployeeApproval from './pages/CreateEmployeeApproval';
import FetchBranches from './pages/FetchBranches';
import RequestReceivedPage from './pages/RequestReceivedPage';
import SettingsPage from './pages/SettingsPage';
import StoreQr from './pages/StoreQr';
import PriceCabineTable from './pages/priceCabineTable';
import StoreList from './pages/StoreList';
import EditStore from './pages/EditStore';
import AvmList from './pages/AvmList';
import ManuelHandShakeList from './pages/Handshake-list';
import ProfilePage from './pages/ProfilePage';
import CargoCourierPage from './pages/CargoCourierPage';
import CargoCourierMasterPage from './pages/CargoCourierMasterPage';
import CargoCourierAVMPage from './pages/CargoCourierAVMPage';
import SupportTickets from './pages/SupportTickets';
import PointsPage from './pages/PointsPage';
import EditUserForPoint from './pages/EditUserForPoint';
import DataTableTest from './pages/DataTableTest';
import CreateReport from './pages/CreateReport';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import PreHandshake from './pages/PreHandshake';
import PreHandshakeList from './pages/PreHandshakeList';
import CampaignPage from './pages/CampaignPage';
import SafeBoxReport from './pages/SafeBoxReport';
import SafeBoxOperations from './pages/SafeBoxOperations';
import CreateForm from './pages/CreateForm';
import TutorialPage from './pages/TutorialPage';
import Checkroom from './pages/Checkroom';
import StoreAuthorizations from './pages/StoreAuthorizations';
import StoreAuthorizationsV2 from './pages/StoreAuthorizations_v2';
import HandshakesReportPage from './pages/HandshakesReportPage';
import HandshakeDetailPage from './pages/HandshakeDetailPage';
import LogSearch from './pages/LogSearch';
import ReceiptOperations from './pages/ReceiptOperations';
import SafeBoxOperationsFake from './pages/SafeBoxOperationsFake';
import CheckroomFake from './pages/CheckroomFake';
import HandsfreePageFake from './pages/HandsfreePageFake';
import StoreTutorialPage from './pages/StoreTutorialPage';
import PorterTutorialPage from './pages/PorterTutorialPage';
import MallManagementTutorialPage from './pages/MallManagementTutorialPage';
import CollectionTransactions from './pages/CollectionTransactions';
import EasyMall from './pages/EasyMall';
import PostTaskCheckList from './pages/PostTaskCheckList';
import FaqPage from './pages/FaqPage';
import FaqManagementPage from './pages/FaqManagementPage';
import PayBill from './pages/PayBillPage';
import PaidBill from './pages/PaidBill';
import PaymentBill from './pages/PaymentBill';
import EasyMallList from './pages/EasyMallList';
import SuccessPaymentBill from './pages/SuccessPaymentBill';
import InvoicePaymentList from './pages/InvoicePaymentList';
import PersonalPackages from './pages/PersonalPackages';
import StoreInformationForm from './pages/StoreInformationForm';
import MallManagementStatistics from './pages/MallManagementStatistics';
import MallManagementUserAuth from './pages/MallManagementUserAuth';
import AvmPermissionsManagement from './pages/AvmPermissionsManagement';
import MallManagementGoodsAcceptance from './pages/MallManagementGoodsAcceptance';
import MallManagementCorrespondence from './pages/MallManagementCorrespondence';
import MallManagementSafetyLocker from './pages/MallManagementSafetyLocker';
import MallManagementSafetyCloakroom from './pages/MallManagementSafetyCloakroom';
import MallManagementClickAndCollect from './pages/MallManagementClickAndCollect';
import MallManagementCargo from './pages/MallManagementCargo';
import MallManagementHomeDelivery from './pages/MallManagementHomeDelivery';
import MallManagementTaxFree from './pages/MallManagementTaxFree';
import MallManagementPetCar from './pages/MallManagementPetCar';
import MallManagementKidCar from './pages/MallManagementKidCar';
import MallManagementHandsFree from './pages/MallManagementHandsfree';
import MallManagementPostBox from './pages/MallManagementPostBox';
import MallManagementEasyMall from './pages/MallManagementEasyMall';
import MallManagementGift from './pages/MallManagementGift';
import CorporateInformation from './pages/CorporateInformation';
import LiveOperationTracking from './pages/LiveOperationTracking';
import LiveOperationTrackingRegionMaster from './pages/LiveOperationTrackingRegionMaster';
import RequestPermission from './pages/RequestPermission';
import MallManagementPreview from './pages/MallManagementPreview';
import OrderReportPage from './pages/OrderReportPage';
// import ShiftCheckinOutTeamLeader from './pages/ShiftCheckinOut/ShiftCheckinOutTeamLeader';
// import ShiftCheckinOutRegionMaster from './pages/ShiftCheckinOut/ShiftCheckinOutRegionMaster';
// import ShiftCheckinOutHighAdmin from './pages/ShiftCheckinOut/ShiftCheckinOutHighAdmin';
import SurveyResponses from './pages/SurveyResponses';
import SurveySolutions from './pages/SurveySolutions';
import FaqWithoutLogin from './pages/FaqWithoutLogin';
import MallAlertBlockSystem from './pages/MallAlertBlockSystem';
import MallAlertBlockRecords from './pages/MallAlertBlockRecords';
import BlockedStoreList from './pages/BlockedStoreList';
// ----------------------------------------------------------------------

function DashboardIndex() {
  let user = null;
  try {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      user = JSON.parse(userJson);
    }
  } catch (e) {
    console.error('LocalStorage "user" okunamadı:', e);
  }

  const redirectPath = getFirstAllowedNavPath(user);

  if (!redirectPath) {
    return (
      <div style={{ padding: 24 }}>
        Herhangi bir sayfaya erişim yetkiniz bulunmamaktadır. Lütfen
        yöneticinizle iletişime geçin.
      </div>
    );
  }

  return <Navigate to={redirectPath} replace />;
}

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <DashboardIndex />, index: true },
        {
          path: 'app',
          element: (
            <ProtectedRoute>
              <DashboardAppPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'finished-jobs',
          element: (
            <ProtectedRoute>
              <FinishedJobsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'finished-jobs-detail/:id',
          element: (
            <ProtectedRoute>
              <FinishedJobsDetailPage />
            </ProtectedRoute>
          ),
        },
        {
          path: '/dashboard/request-permission',
          element: (
            <ProtectedRoute>
              <RequestPermission />
            </ProtectedRoute>
          ),
        },
        {
          path: '/dashboard/live-operations-tracking',
          element: (
            <ProtectedRoute>
              <LiveOperationTracking />
            </ProtectedRoute>
          ),
        },
        {
          path: '/dashboard/live-operations-tracking-region-master',
          element: (
            <ProtectedRoute>
              <LiveOperationTrackingRegionMaster />
            </ProtectedRoute>
          ),
        },
        {
          path: 'porters',
          element: (
            <ProtectedRoute>
              <Porters />
            </ProtectedRoute>
          ),
        },
        {
          path: 'store-authorizations',
          element: (
            <ProtectedRoute>
              <StoreAuthorizations />
            </ProtectedRoute>
          ),
        },
        { path: 'store-authorizations-v2', element: <StoreAuthorizationsV2 /> },
        {
          path: 'users',
          element: (
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'muhaberat-entry',
          element: (
            <ProtectedRoute>
              <MuhaberatEntryPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-courier',
          element: (
            <ProtectedRoute>
              <CargoCourierPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-courier/master',
          element: (
            <ProtectedRoute>
              <CargoCourierMasterPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-courier/avm',
          element: (
            <ProtectedRoute>
              <CargoCourierAVMPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'muhaberat-output',
          element: (
            <ProtectedRoute>
              <MuhaberatOutput />
            </ProtectedRoute>
          ),
        },
        {
          path: 'muhaberat-output-users',
          element: (
            <ProtectedRoute>
              <MuhaberatOutputUsers />
            </ProtectedRoute>
          ),
        },
        {
          path: 'store-list',
          element: (
            <ProtectedRoute>
              <StoreList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets/:id',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets/complete/:id',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'edit-store/:id/:mallID',
          element: (
            <ProtectedRoute>
              <EditStore />
            </ProtectedRoute>
          ),
        },
        {
          path: 'avm-list',
          element: (
            <ProtectedRoute>
              <AvmList />
            </ProtectedRoute>
          ),
        },
        { path: 'mall-alert-block-system', element: <MallAlertBlockSystem /> },
        {
          path: 'mall-alert-block-records',
          element: <MallAlertBlockRecords />,
        },
        { path: 'blocked-store-list', element: <BlockedStoreList /> },
        {
          path: 'avm-permissions-management',
          element: (
            <ProtectedRoute>
              <AvmPermissionsManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: 'manuel-handshake',
          element: (
            <ProtectedRoute>
              <ManuelHandShake />
            </ProtectedRoute>
          ),
        },
        {
          path: 'manuel-handshake-list',
          element: (
            <ProtectedRoute>
              <ManuelHandShakeList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'pre-handshake-list',
          element: (
            <ProtectedRoute>
              <PreHandshakeList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'handsfree',
          element: (
            <ProtectedRoute>
              <HandsfreePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'handsfree-sample',
          element: (
            <ProtectedRoute>
              <HandsfreePageFake />
            </ProtectedRoute>
          ),
        },
        {
          path: 'all-actions',
          element: (
            <ProtectedRoute>
              <AllActionsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'handshakes-report-list',
          element: (
            <ProtectedRoute>
              <HandshakesReportPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'handshake-detail/:handshakeID/:documentNo',
          element: (
            <ProtectedRoute>
              <HandshakeDetailPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'robot-lists',
          element: (
            <ProtectedRoute>
              <RobotListsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'robot-actions',
          element: (
            <ProtectedRoute>
              <RobotActionsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'monthly-prices',
          element: (
            <ProtectedRoute>
              <PriceTablePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'monthly-cabine',
          element: (
            <ProtectedRoute>
              <PriceCabineTable />
            </ProtectedRoute>
          ),
        },
        {
          path: 'users',
          element: (
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'points',
          element: (
            <ProtectedRoute>
              <PointsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'corporate-list',
          element: (
            <ProtectedRoute>
              <CorporateInformation />
            </ProtectedRoute>
          ),
        },
        {
          path: 'edit-point-user/:id',
          element: (
            <ProtectedRoute>
              <EditUserForPoint />
            </ProtectedRoute>
          ),
        },
        {
          path: 'technical-support-requests',
          element: (
            <ProtectedRoute>
              <TechnicalSupportRequests />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-employee-approval',
          element: (
            <ProtectedRoute>
              <CreateEmployeeApproval />
            </ProtectedRoute>
          ),
        },
        {
          path: 'fetch-branches',
          element: (
            <ProtectedRoute>
              <FetchBranches />
            </ProtectedRoute>
          ),
        },
        {
          path: 'qr',
          element: (
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'store-qr',
          element: (
            <ProtectedRoute>
              <StoreQr />
            </ProtectedRoute>
          ),
        },
        {
          path: 'profile',
          element: (
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'data-table',
          element: (
            <ProtectedRoute>
              <DataTableTest />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-report',
          element: (
            <ProtectedRoute>
              <CreateReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'campaign',
          element: (
            <ProtectedRoute>
              <CampaignPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-form',
          element: (
            <ProtectedRoute>
              <CreateForm />
            </ProtectedRoute>
          ),
        },
        {
          path: 'survey-responses/:id',
          element: (
            <ProtectedRoute>
              <SurveyResponses />
            </ProtectedRoute>
          ),
        },
        {
          path: 'safe-box-report',
          element: (
            <ProtectedRoute>
              <SafeBoxReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'safe-box-operations',
          element: (
            <ProtectedRoute>
              <SafeBoxOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'checkroom',
          element: (
            <ProtectedRoute>
              <Checkroom />
            </ProtectedRoute>
          ),
        },
        {
          path: 'collection-transactions',
          element: (
            <ProtectedRoute>
              <CollectionTransactions />
            </ProtectedRoute>
          ),
        },
        // {
        //   path: 'shift-checkin-out-team-leader',
        //   element: (
        //     <ProtectedRoute>
        //       <ShiftCheckinOutTeamLeader />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: 'shift-checkin-out-region-manager',
        //   element: (
        //     <ProtectedRoute>
        //       <ShiftCheckinOutRegionMaster />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: 'shift-checkin-out-high-admin',
        //   element: (
        //     <ProtectedRoute>
        //       <ShiftCheckinOutHighAdmin />
        //     </ProtectedRoute>
        //   ),
        // },
        {
          path: 'safe-box-operations-sample',
          element: (
            <ProtectedRoute>
              <SafeBoxOperationsFake />
            </ProtectedRoute>
          ),
        },
        {
          path: 'checkroom-sample',
          element: (
            <ProtectedRoute>
              <CheckroomFake />
            </ProtectedRoute>
          ),
        },

        {
          path: 'tutorials',
          element: (
            <ProtectedRoute>
              <TutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'store-tutorial',
          element: (
            <ProtectedRoute>
              <StoreTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'porter-tutorial',
          element: (
            <ProtectedRoute>
              <PorterTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-tutorial',
          element: (
            <ProtectedRoute>
              <MallManagementTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'faq',
          element: (
            <ProtectedRoute>
              <FaqPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'faq-management',
          element: (
            <ProtectedRoute>
              <FaqManagementPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'log-search',
          element: (
            <ProtectedRoute>
              <LogSearch />
            </ProtectedRoute>
          ),
        },
        {
          path: 'receipt-operations',
          element: (
            <ProtectedRoute>
              <ReceiptOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-statistics',
          element: (
            <ProtectedRoute>
              <MallManagementStatistics />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-preview',
          element: (
            <ProtectedRoute>
              <MallManagementPreview />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-user-authorization',
          element: (
            <ProtectedRoute>
              <MallManagementUserAuth />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-goods-acceptance',
          element: (
            <ProtectedRoute>
              <MallManagementGoodsAcceptance />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-courier-order-report',
          element: (
            <ProtectedRoute>
              <OrderReportPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-correspondence',
          element: (
            <ProtectedRoute>
              <MallManagementCorrespondence />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-safety-locker',
          element: (
            <ProtectedRoute>
              <MallManagementSafetyLocker />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-safety-cloakroom',
          element: (
            <ProtectedRoute>
              <MallManagementSafetyCloakroom />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-click-collect',
          element: (
            <ProtectedRoute>
              <MallManagementClickAndCollect />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-cargo',
          element: (
            <ProtectedRoute>
              <MallManagementCargo />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-home-delivery',
          element: (
            <ProtectedRoute>
              <MallManagementHomeDelivery />
            </ProtectedRoute>
          ),
        },

        {
          path: 'mall-management-tax-free',
          element: (
            <ProtectedRoute>
              <MallManagementTaxFree />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-pet-car',
          element: (
            <ProtectedRoute>
              <MallManagementPetCar />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-kid-car',
          element: (
            <ProtectedRoute>
              <MallManagementKidCar />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-handsfree',
          element: (
            <ProtectedRoute>
              <MallManagementHandsFree />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-postbox',
          element: (
            <ProtectedRoute>
              <MallManagementPostBox />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-easymall',
          element: (
            <ProtectedRoute>
              <MallManagementEasyMall />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-management-gift',
          element: (
            <ProtectedRoute>
              <MallManagementGift />
            </ProtectedRoute>
          ),
        },
        {
          path: 'easy-mall',
          element: (
            <ProtectedRoute>
              <EasyMall />
            </ProtectedRoute>
          ),
        },
        {
          path: 'easy-mall-list',
          element: (
            <ProtectedRoute>
              <EasyMallList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'invoice-payment-list',
          element: (
            <ProtectedRoute>
              <InvoicePaymentList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'post-task-checklist',
          element: (
            <ProtectedRoute>
              <PostTaskCheckList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'personal-packages',
          element: (
            <ProtectedRoute>
              <PersonalPackages />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: 'store-information-form',
      element: <StoreInformationForm />,
    },
    {
      path: 'form-without-login',
      element: <FormWithoutLogin />,
    },
    {
      path: 'sss',
      element: <FaqWithoutLogin />,
    },
    {
      path: 'sss/:type',
      element: <FaqWithoutLogin />,
    },
    {
      path: 'sss/:type/:source',
      element: <FaqWithoutLogin />,
    },
    {
      path: 'pay-bill',
      element: <PayBill />,
    },
    {
      path: 'paid-bill',
      element: <PaidBill />,
    },
    {
      path: 'payment-bill',
      element: <PaymentBill />,
    },
    {
      path: 'success-payment-bill',
      element: <SuccessPaymentBill />,
    },
    {
      path: 'request-received',
      element: <RequestReceivedPage />,
    },
    {
      path: 'pre-handshake/:avmID',
      element: <PreHandshake />,
    },
    {
      path: 'survey/:id',
      element: <SurveySolutions />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
